import produce from "immer";

import {
	SET_ACCESS_TOKEN,
	SET_AUTHENTICATED,
	SET_LOADING_APP,
	SET_POPUP,
	SET_REFRESH_TOKEN,
} from "./constants";

export const initialState = {
	isAuthenticated: false,
	accessToken: null,
	refreshToken: null,
	isLoading: false,
	popup: {
		isOpen: false,
		content: null,
	},
};

// * state key that will stored to localStorage
export const storedKey = ["accessToken", "refreshToken"];

/* eslint-disable default-case, no-param-reassign */
const appReducer = (state = initialState, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			case SET_ACCESS_TOKEN:
				draft.accessToken = action.accessToken;
				break;
			case SET_REFRESH_TOKEN:
				draft.refreshToken = action.refreshToken;
				break;
			case SET_AUTHENTICATED:
				draft.isAuthenticated = action.isAuthenticated;
				break;
			case SET_LOADING_APP:
				draft.isLoading = action.isLoading;
				break;
			case SET_POPUP:
				draft.popup = action.popup;
				break;
		}
	});

export default appReducer;
